import React, { useMemo, useCallback } from 'react';

import { Grid, Select, TextField } from '@gogame/components';
import { withFormField } from '@gogame/form';

const EMPTY_OPTIONS = [];

const CUSTOM_OPTION = { name: 'Custom source' };

const getOptionValue = (option) => option;

export default withFormField()(({
  value: { id: valueId, name: valueName } = {},
  onChange,
  loading,
  data,
  selectedMediaSourceIsConstant,
  initialValue,
  customSourceHelperText,
  required,
  error,
}) => {
  const valueNameNotEmpty = valueName !== undefined;

  const customSource =
    valueNameNotEmpty && data && !selectedMediaSourceIsConstant;

  const options = useMemo(() => {
    return data ? [...data, CUSTOM_OPTION] : EMPTY_OPTIONS;
  }, [data]);

  const selectedOption = useMemo(() => {
    if (valueId) {
      return data?.find(({ id }) => id === valueId) || CUSTOM_OPTION;
    }

    return valueNameNotEmpty ? CUSTOM_OPTION : null;
  }, [options, valueId, valueNameNotEmpty]);

  const handleChange = useCallback(
    (e, value) => {
      onChange(e, value === CUSTOM_OPTION ? { name: '' } : value);
    },
    [onChange]
  );

  const handleChangeCustom = useCallback(
    (e) => {
      onChange(e, { name: e.target.value });
    },
    [onChange]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Select
          label={'Media source'}
          loading={loading}
          options={options}
          value={selectedOption}
          disabled={Boolean(initialValue)}
          getOptionValue={getOptionValue}
          onChange={handleChange}
          required={required}
          error={!customSource && error}
        />
      </Grid>
      {customSource ? (
        <Grid item xs={6}>
          <TextField
            label={'Custom source'}
            value={valueName}
            onChange={handleChangeCustom}
            fullWidth={true}
            helperText={customSourceHelperText}
            required={required}
            error={error}
          />
        </Grid>
      ) : null}
    </Grid>
  );
});
